import React, { useState, useEffect } from 'react';
import { db } from '../firebaseConfig';
import { collection, query, orderBy, onSnapshot, doc, updateDoc, deleteDoc } from 'firebase/firestore';

const styles = {
    container: { paddingTop: '6rem', paddingLeft: '2rem', paddingRight: '2rem', paddingBottom: '2rem', fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif', color: '#2c3e50' },
    header: { fontSize: '2.5rem', fontWeight: '700', color: '#2c3e50', marginBottom: '1.5rem', paddingBottom: '0.5rem', borderBottom: '2px solid #bdc3c7' },
    reviewCard: { border: '1px solid #eee', borderRadius: '8px', padding: '15px', marginBottom: '15px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', backgroundColor: 'white' },
    reviewAuthor: { fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '5px' },
    reviewRating: { color: '#f39c12', marginBottom: '5px' }, // Star color
    reviewComment: { fontSize: '1rem', color: '#555', marginBottom: '10px' },
    reviewStatus: { padding: '5px 10px', borderRadius: '15px', fontWeight: 'bold', display: 'inline-block', minWidth: '80px', textAlign: 'center', marginRight: '10px' },
    statusPending: { backgroundColor: '#f1c40f', color: 'white' },
    statusApproved: { backgroundColor: '#2ecc71', color: 'white' },
    statusRejected: { backgroundColor: '#e74c3c', color: 'white' },
    button: { padding: '8px 12px', cursor: 'pointer', color: 'white', border: 'none', borderRadius: '5px', fontWeight: 'bold', transition: 'background-color 0.2s ease', marginRight: '10px' },
    buttonApprove: { backgroundColor: '#2ecc71' },
    buttonReject: { backgroundColor: '#e67e22' },
    buttonDelete: { backgroundColor: '#e74c3c' },
};

function AdminReviews() {
    const [reviews, setReviews] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const q = query(collection(db, 'reviews'), orderBy('createdAt', 'desc'));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            const fetchedReviews = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setReviews(fetchedReviews);
            setLoading(false);
        }, (error) => {
            console.error("Error fetching reviews: ", error);
            alert("Error al cargar las reseñas: " + error.message);
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    const updateReviewStatus = async (reviewId, status) => {
        try {
            const reviewRef = doc(db, 'reviews', reviewId);
            await updateDoc(reviewRef, { status });
            alert(`Reseña ${status} con éxito.`);
        } catch (error) {
            console.error("Error updating review status: ", error);
            alert("Error al actualizar el estado de la reseña.");
        }
    };

    const deleteReview = async (reviewId) => {
        if (window.confirm("¿Estás seguro de que quieres eliminar esta reseña? Esta acción es irreversible.")) {
            try {
                await deleteDoc(doc(db, 'reviews', reviewId));
                alert("Reseña eliminada con éxito.");
            } catch (error) {
                console.error("Error deleting review: ", error);
                alert("Error al eliminar la reseña.");
            }
        }
    };

    const getStatusStyle = (status) => {
        switch (status) {
            case 'pending': return styles.statusPending;
            case 'approved': return styles.statusApproved;
            case 'rejected': return styles.statusRejected;
            default: return {};
        }
    };

    if (loading) {
        return <p style={styles.container}>Cargando reseñas...</p>;
    }

    return (
        <div style={styles.container}>
            <h1 style={styles.header}>Administrar Reseñas</h1>
            {reviews.length === 0 ? (
                <p>No hay reseñas para mostrar.</p>
            ) : (
                <div>
                    {reviews.map(review => (
                        <div key={review.id} style={styles.reviewCard}>
                            <p style={styles.reviewAuthor}>{review.author || 'Anónimo'}</p>
                            <p style={styles.reviewRating}>{'⭐'.repeat(review.rating || 0)}</p>
                            <p style={styles.reviewComment}>{review.comment}</p>
                            <span style={{ ...styles.reviewStatus, ...getStatusStyle(review.status) }}>
                                {review.status ? review.status.toUpperCase() : 'PENDING'}
                            </span>
                            <p style={{ fontSize: '0.8em', color: '#888' }}>
                                Fecha: {review.createdAt?.toDate().toLocaleString() || 'N/A'}
                            </p>
                            <div>
                                {review.status !== 'approved' && (
                                    <button 
                                        style={{ ...styles.button, ...styles.buttonApprove }} 
                                        onClick={() => updateReviewStatus(review.id, 'approved')}
                                    >
                                        Aprobar
                                    </button>
                                )}
                                {review.status !== 'rejected' && (
                                    <button 
                                        style={{ ...styles.button, ...styles.buttonReject }} 
                                        onClick={() => updateReviewStatus(review.id, 'rejected')}
                                    >
                                        Rechazar
                                    </button>
                                )}
                                <button 
                                    style={{ ...styles.button, ...styles.buttonDelete }} 
                                    onClick={() => deleteReview(review.id)}
                                >
                                    Eliminar
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default AdminReviews;
